import { ui } from "../../../../../../../../../../interfaces/interfaces";
import { TradeType, TradeTypes } from "@utils/BasicTypes";

export const handleTradeChange = (event: React.SyntheticEvent<Element, Event>, value: TradeType) => {
  ui.ProblemComboTrade = value;
};

export const tradeGetOptionLabel = (options: TradeType) => options.tradeDescription;
export const tradeIsOptionEqualToValue = (option: TradeType, value: TradeType) =>
  option?.tradeCode === value?.tradeCode;
export const tradeTypeOptions = (tradeTypes: TradeTypes | []) =>
  tradeTypes && tradeTypes?.length > 0 ? tradeTypes : [];
